export interface StockpileSourceOption {
  id: string;
  name: string;
  /** False only for the current source when it is not in the scene (edit
   *  mode on a stockpile whose cloud is hidden) — compute will refuse it. */
  loaded: boolean;
}

/**
 * Point clouds the stockpile compute can sample (D10). Only clouds loaded in
 * the scene qualify — `computeStockpileVolume` walks the live octree — plus
 * the current source when it is not loaded, so the picker never misreports
 * which cloud the saved stockpile belongs to.
 */
export function stockpileSourceOptions(
  loadedLayerIds: readonly string[],
  layers: readonly { id: string; name: string }[],
  currentId: string | null,
): StockpileSourceOption[] {
  const nameOf = (id: string) => layers.find((l) => l.id === id)?.name ?? id;
  const seen = new Set<string>();
  const out: StockpileSourceOption[] = [];
  for (const id of loadedLayerIds) {
    if (seen.has(id)) continue;
    seen.add(id);
    out.push({ id, name: nameOf(id), loaded: true });
  }
  if (currentId && !seen.has(currentId)) out.unshift({ id: currentId, name: nameOf(currentId), loaded: false });
  return out;
}
